module.exports = __webpack_public_path__ + "static/media/file-zip.4da5575b.svg";